var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3751 13.1251C20.6251 16.8751 17.7976 20.4061 13.8301 21.1951C11.8951 21.5804 9.88781 21.3455 8.0941 20.5237C6.30039 19.7018 4.81167 18.3351 3.83993 16.618C2.8682 14.9008 2.46297 12.9209 2.68196 10.9601C2.90094 8.99926 3.73298 7.15751 5.05959 5.69707C7.78059 2.70007 12.3751 1.87507 16.1251 3.37507",
    stroke: "#0FA958",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 11.625L12.375 15.375L21.375 5.625",
    stroke: "#0FA958",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.54855b729fd477df97908da3d7e4b800.svg";
export { ForwardRef as ReactComponent };